import { jsx as l } from "react/jsx-runtime";
import { cn as a } from "@tameeni/shared-logic";
function r({ children: t, isSelected: o }) {
  return /* @__PURE__ */ l(
    "span",
    {
      className: a(
        "absolute top-px start-4 text-b2 text-slate-500 transition-all capitalize",
        o ? "slide-in-from-bottom-full" : "slide-out-to-bottom-full opacity-0"
      ),
      children: t
    }
  );
}
export {
  r as default
};
